import { OutlinedInput, OutlinedInputProps } from "@mui/material";

import * as S from "./styles";
import {
  Control,
  Controller,
  FieldError,
  FieldValues,
  Path,
} from "react-hook-form";

export interface RoundInputProps<T extends FieldValues> extends OutlinedInputProps {
  topLabel?: string;
  errorText?: FieldError;
  control?: Control<T>;
  inputName?: Path<T>;
}

export default function RoundInput<T extends FieldValues>({
  topLabel,
  errorText,
  inputName,
  control,
  ...props
}: RoundInputProps<T>) {
  return inputName && control ? (
    <Controller
      name={inputName}
      control={control}
      render={({ field }) => (
        <S.InputContainer>
          {topLabel ? <p>{topLabel}</p> : null}
          <S.StyledOutlined  {...field} {...props} />
          {errorText ? (
            <small>
              {errorText.message}
            </small>
          ) : null}
        </S.InputContainer>
      )}
    />
  ) : (
    <S.InputContainer>
      {topLabel ? <p>{topLabel}</p> : null}
      <S.StyledOutlined {...props} />
      {errorText ? (
        <small>
          {errorText.message}
        </small>
      ) : null}
    </S.InputContainer>
  );
}
